// src/components/Auth/Unauthorized.js
import React from 'react';
import { Container, Typography, Box } from '@mui/material';

const Unauthorized = () => {
  return (
    <Container maxWidth="sm">
      <Box mt={10} p={4} boxShadow={3} textAlign="center">
        <Typography variant="h4" gutterBottom>
          Acceso Denegado
        </Typography>
        <Typography variant="body1">
          No tienes los permisos necesarios para acceder a esta página.
        </Typography>
      </Box>
    </Container>
  );
};

export default Unauthorized;
